import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { KTSVG, MenuPaths } from '../../../helpers'
import { useLayout } from '../../core'
import { HeaderToolbar } from './HeaderToolbar'
import { LogoComponent } from 'app/components'

export function HeaderWrapper() {
  const { config, classes, attributes } = useLayout()
  const { aside } = config

  return (
    <div
      id='kt_header'
      className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
      {...attributes.headerMenu}
    >
      <div className='header-brand'>
        <Link
          to='/'
          className='header-logo d-flex align-items-center flex-shrink-1 me-3'
          style={{ minWidth: 0 }}
        >
          <LogoComponent variant='dark' />
        </Link>

        {aside.minimize && (
          <button
            type='button'
            id='kt_aside_toggle'
            className='btn btn-icon w-auto px-0 aside-minimize'
            aria-label='Recolher ou expandir menu lateral'
            data-kt-toggle='true'
            data-kt-toggle-state='active'
            data-kt-toggle-target='body'
            data-kt-toggle-name='aside-minimize'
          >
            <KTSVG path={MenuPaths.Menu} className='header-menu-toggle-icon' />
          </button>
        )}

        <div className='d-flex align-items-center d-lg-none ms-n3 me-1'>
          <button
            type='button'
            className='btn btn-icon w-30px h-30px'
            id='kt_aside_mobile_toggle'
            aria-label='Abrir menu lateral'
          >
            <KTSVG path={MenuPaths.Menu} className='header-menu-toggle-icon' />
          </button>
        </div>
      </div>
      <HeaderToolbar />
    </div>
  )
}
